import { useLocation } from 'react-router'

const useUrlIncludes = (url: string) => {
  const { pathname } = useLocation()
  return pathname.includes(url)
}

export default useUrlIncludes
